import { api } from './authenticationApi';

/**
 *  Fetch a page of researches/personas/responses.
 *
 *  @param {Object} opts
 *  @param {number} [opts.limit=10]  - how many researches to fetch
 *  @param {string|null} [opts.cursor=null] - opaque cursor returned by the
 *                                            previous call (null for first page)
 *
 *  The server answers with
 *  {
 *     researches : [...],
 *     personas   : [...],
 *     responses  : [...],
 *     nextCursor : "eyJ1c2VySUQiOiIuLi4iLCJyZXNlYXJjaElEIjoiLi4uIn0=" | null
 *  }
 */
export const dataApi = {

  fetchPage: async ({ limit = 10, cursor = null } = {}) => {
    // Build the query-string: ?limit=10&cursor=xxxxx
    const qs = new URLSearchParams();
    if (limit)  qs.append('limit',  limit);
    if (cursor) qs.append('cursor', cursor);

    const endpoint =
      qs.toString() ? `/data/aggregate?${qs.toString()}` : '/data/aggregate';

    return await api.makeAuthenticatedRequest(endpoint, { method: 'GET' });
  },

  // --- NEW FUNCTION ---
  fetchSharedLinks: async () => {
    return await api.makeAuthenticatedRequest('/data/shared-links', { method: 'GET' });
  },
  // --------------------

  /**
   * Download PDF using the Data-Driven approach.
   * @param {Object} userData - The full state object from React
   */
  downloadPdf: async (userData) => {
    // We send the DATA, not just the ID.
    // Note: ensure 'api' wrapper supports POST with responseType: 'blob'
    return await api.makeAuthenticatedRequest('/share/download-pdf', { 
      method: 'POST',
      body: userData,       // Pass the whole object
    });
  },

  getSharedResearch: async (shareID) => {
    // Uses the new public request helper
    const result = await api.makePublicRequest(`/research/share/${shareID}`, { 
      method: 'GET' 
    });
    // Return the inner data object { research, personas, responses }
    return result.data; 
  }

};

